/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  DeleteFleetsFleetIdMembersMemberIdNotFound,
  DeleteFleetsFleetIdSquadsSquadIdNotFound,
  DeleteFleetsFleetIdWingsWingIdNotFound,
  ErrorLimited,
  Forbidden,
  GatewayTimeout,
  GetCharactersCharacterIdFleetNotFound,
  GetCharactersCharacterIdFleetOk,
  GetFleetsFleetIdMembers200Ok,
  GetFleetsFleetIdMembersNotFound,
  GetFleetsFleetIdNotFound,
  GetFleetsFleetIdOk,
  GetFleetsFleetIdWings200Ok,
  GetFleetsFleetIdWingsNotFound,
  InternalServerError,
  PostFleetsFleetIdMembersInvitation,
  PostFleetsFleetIdMembersNotFound,
  PostFleetsFleetIdMembersUnprocessableEntity,
  PostFleetsFleetIdWingsCreated,
  PostFleetsFleetIdWingsNotFound,
  PostFleetsFleetIdWingsWingIdSquadsCreated,
  PostFleetsFleetIdWingsWingIdSquadsNotFound,
  PutFleetsFleetIdMembersMemberIdMovement,
  PutFleetsFleetIdMembersMemberIdNotFound,
  PutFleetsFleetIdMembersMemberIdUnprocessableEntity,
  PutFleetsFleetIdNewSettings,
  PutFleetsFleetIdNotFound,
  PutFleetsFleetIdSquadsSquadIdNaming,
  PutFleetsFleetIdSquadsSquadIdNotFound,
  PutFleetsFleetIdWingsWingIdNaming,
  PutFleetsFleetIdWingsWingIdNotFound,
  ServiceUnavailable,
  Unauthorized,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    DeleteFleetsFleetIdMembersMemberIdNotFoundFromJSON,
    DeleteFleetsFleetIdMembersMemberIdNotFoundToJSON,
    DeleteFleetsFleetIdSquadsSquadIdNotFoundFromJSON,
    DeleteFleetsFleetIdSquadsSquadIdNotFoundToJSON,
    DeleteFleetsFleetIdWingsWingIdNotFoundFromJSON,
    DeleteFleetsFleetIdWingsWingIdNotFoundToJSON,
    ErrorLimitedFromJSON,
    ErrorLimitedToJSON,
    ForbiddenFromJSON,
    ForbiddenToJSON,
    GatewayTimeoutFromJSON,
    GatewayTimeoutToJSON,
    GetCharactersCharacterIdFleetNotFoundFromJSON,
    GetCharactersCharacterIdFleetNotFoundToJSON,
    GetCharactersCharacterIdFleetOkFromJSON,
    GetCharactersCharacterIdFleetOkToJSON,
    GetFleetsFleetIdMembers200OkFromJSON,
    GetFleetsFleetIdMembers200OkToJSON,
    GetFleetsFleetIdMembersNotFoundFromJSON,
    GetFleetsFleetIdMembersNotFoundToJSON,
    GetFleetsFleetIdNotFoundFromJSON,
    GetFleetsFleetIdNotFoundToJSON,
    GetFleetsFleetIdOkFromJSON,
    GetFleetsFleetIdOkToJSON,
    GetFleetsFleetIdWings200OkFromJSON,
    GetFleetsFleetIdWings200OkToJSON,
    GetFleetsFleetIdWingsNotFoundFromJSON,
    GetFleetsFleetIdWingsNotFoundToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    PostFleetsFleetIdMembersInvitationFromJSON,
    PostFleetsFleetIdMembersInvitationToJSON,
    PostFleetsFleetIdMembersNotFoundFromJSON,
    PostFleetsFleetIdMembersNotFoundToJSON,
    PostFleetsFleetIdMembersUnprocessableEntityFromJSON,
    PostFleetsFleetIdMembersUnprocessableEntityToJSON,
    PostFleetsFleetIdWingsCreatedFromJSON,
    PostFleetsFleetIdWingsCreatedToJSON,
    PostFleetsFleetIdWingsNotFoundFromJSON,
    PostFleetsFleetIdWingsNotFoundToJSON,
    PostFleetsFleetIdWingsWingIdSquadsCreatedFromJSON,
    PostFleetsFleetIdWingsWingIdSquadsCreatedToJSON,
    PostFleetsFleetIdWingsWingIdSquadsNotFoundFromJSON,
    PostFleetsFleetIdWingsWingIdSquadsNotFoundToJSON,
    PutFleetsFleetIdMembersMemberIdMovementFromJSON,
    PutFleetsFleetIdMembersMemberIdMovementToJSON,
    PutFleetsFleetIdMembersMemberIdNotFoundFromJSON,
    PutFleetsFleetIdMembersMemberIdNotFoundToJSON,
    PutFleetsFleetIdMembersMemberIdUnprocessableEntityFromJSON,
    PutFleetsFleetIdMembersMemberIdUnprocessableEntityToJSON,
    PutFleetsFleetIdNewSettingsFromJSON,
    PutFleetsFleetIdNewSettingsToJSON,
    PutFleetsFleetIdNotFoundFromJSON,
    PutFleetsFleetIdNotFoundToJSON,
    PutFleetsFleetIdSquadsSquadIdNamingFromJSON,
    PutFleetsFleetIdSquadsSquadIdNamingToJSON,
    PutFleetsFleetIdSquadsSquadIdNotFoundFromJSON,
    PutFleetsFleetIdSquadsSquadIdNotFoundToJSON,
    PutFleetsFleetIdWingsWingIdNamingFromJSON,
    PutFleetsFleetIdWingsWingIdNamingToJSON,
    PutFleetsFleetIdWingsWingIdNotFoundFromJSON,
    PutFleetsFleetIdWingsWingIdNotFoundToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
} from '../models/index';

export interface DeleteFleetsFleetIdMembersMemberIdRequest {
    fleetId: number;
    memberId: number;
    datasource?: DeleteFleetsFleetIdMembersMemberIdDatasourceEnum;
    token?: string;
}

export interface DeleteFleetsFleetIdSquadsSquadIdRequest {
    fleetId: number;
    squadId: number;
    datasource?: DeleteFleetsFleetIdSquadsSquadIdDatasourceEnum;
    token?: string;
}

export interface DeleteFleetsFleetIdWingsWingIdRequest {
    fleetId: number;
    wingId: number;
    datasource?: DeleteFleetsFleetIdWingsWingIdDatasourceEnum;
    token?: string;
}

export interface GetCharactersCharacterIdFleetRequest {
    characterId: number;
    datasource?: GetCharactersCharacterIdFleetDatasourceEnum;
    ifNoneMatch?: string;
    token?: string;
}

export interface GetFleetsFleetIdRequest {
    fleetId: number;
    datasource?: GetFleetsFleetIdDatasourceEnum;
    ifNoneMatch?: string;
    token?: string;
}

export interface GetFleetsFleetIdMembersRequest {
    fleetId: number;
    acceptLanguage?: GetFleetsFleetIdMembersAcceptLanguageEnum;
    datasource?: GetFleetsFleetIdMembersDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetFleetsFleetIdMembersLanguageEnum;
    token?: string;
}

export interface GetFleetsFleetIdWingsRequest {
    fleetId: number;
    acceptLanguage?: GetFleetsFleetIdWingsAcceptLanguageEnum;
    datasource?: GetFleetsFleetIdWingsDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetFleetsFleetIdWingsLanguageEnum;
    token?: string;
}

export interface PostFleetsFleetIdMembersRequest {
    fleetId: number;
    invitation: PostFleetsFleetIdMembersInvitation;
    datasource?: PostFleetsFleetIdMembersDatasourceEnum;
    token?: string;
}

export interface PostFleetsFleetIdWingsRequest {
    fleetId: number;
    datasource?: PostFleetsFleetIdWingsDatasourceEnum;
    token?: string;
}

export interface PostFleetsFleetIdWingsWingIdSquadsRequest {
    fleetId: number;
    wingId: number;
    datasource?: PostFleetsFleetIdWingsWingIdSquadsDatasourceEnum;
    token?: string;
}

export interface PutFleetsFleetIdRequest {
    fleetId: number;
    newSettings: PutFleetsFleetIdNewSettings;
    datasource?: PutFleetsFleetIdDatasourceEnum;
    token?: string;
}

export interface PutFleetsFleetIdMembersMemberIdRequest {
    fleetId: number;
    memberId: number;
    movement: PutFleetsFleetIdMembersMemberIdMovement;
    datasource?: PutFleetsFleetIdMembersMemberIdDatasourceEnum;
    token?: string;
}

export interface PutFleetsFleetIdSquadsSquadIdRequest {
    fleetId: number;
    squadId: number;
    naming: PutFleetsFleetIdSquadsSquadIdNaming;
    datasource?: PutFleetsFleetIdSquadsSquadIdDatasourceEnum;
    token?: string;
}

export interface PutFleetsFleetIdWingsWingIdRequest {
    fleetId: number;
    wingId: number;
    naming: PutFleetsFleetIdWingsWingIdNaming;
    datasource?: PutFleetsFleetIdWingsWingIdDatasourceEnum;
    token?: string;
}

/**
 * 
 */
export class FleetsApi extends runtime.BaseAPI {

    /**
     * Kick a fleet member  --- 
     * Kick fleet member
     */
    async deleteFleetsFleetIdMembersMemberIdRaw(requestParameters: DeleteFleetsFleetIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling deleteFleetsFleetIdMembersMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteFleetsFleetIdMembersMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/members/{member_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"member_id"}}`, encodeURIComponent(String(requestParameters['memberId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Kick a fleet member  --- 
     * Kick fleet member
     */
    async deleteFleetsFleetIdMembersMemberId(requestParameters: DeleteFleetsFleetIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFleetsFleetIdMembersMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a fleet squad, only empty squads can be deleted  --- 
     * Delete fleet squad
     */
    async deleteFleetsFleetIdSquadsSquadIdRaw(requestParameters: DeleteFleetsFleetIdSquadsSquadIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling deleteFleetsFleetIdSquadsSquadId().'
            );
        }

        if (requestParameters['squadId'] == null) {
            throw new runtime.RequiredError(
                'squadId',
                'Required parameter "squadId" was null or undefined when calling deleteFleetsFleetIdSquadsSquadId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/squads/{squad_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"squad_id"}}`, encodeURIComponent(String(requestParameters['squadId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a fleet squad, only empty squads can be deleted  --- 
     * Delete fleet squad
     */
    async deleteFleetsFleetIdSquadsSquadId(requestParameters: DeleteFleetsFleetIdSquadsSquadIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFleetsFleetIdSquadsSquadIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a fleet wing, only empty wings can be deleted. The wing may contain squads, but the squads must be empty  --- 
     * Delete fleet wing
     */
    async deleteFleetsFleetIdWingsWingIdRaw(requestParameters: DeleteFleetsFleetIdWingsWingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling deleteFleetsFleetIdWingsWingId().'
            );
        }

        if (requestParameters['wingId'] == null) {
            throw new runtime.RequiredError(
                'wingId',
                'Required parameter "wingId" was null or undefined when calling deleteFleetsFleetIdWingsWingId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/wings/{wing_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"wing_id"}}`, encodeURIComponent(String(requestParameters['wingId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a fleet wing, only empty wings can be deleted. The wing may contain squads, but the squads must be empty  --- 
     * Delete fleet wing
     */
    async deleteFleetsFleetIdWingsWingId(requestParameters: DeleteFleetsFleetIdWingsWingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFleetsFleetIdWingsWingIdRaw(requestParameters, initOverrides);
    }

    /**
     * Return the fleet ID the character is in, if any.  ---  This route is cached for up to 60 seconds  --- Warning: This route has an upgrade available  --- [Diff of the upcoming changes](https://esi.evetech.net/diff/latest/dev/#GET-/characters/{character_id}/fleet/)
     * Get character fleet info
     */
    async getCharactersCharacterIdFleetRaw(requestParameters: GetCharactersCharacterIdFleetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCharactersCharacterIdFleetOk>> {
        if (requestParameters['characterId'] == null) {
            throw new runtime.RequiredError(
                'characterId',
                'Required parameter "characterId" was null or undefined when calling getCharactersCharacterIdFleet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.read_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/characters/{character_id}/fleet/`.replace(`{${"character_id"}}`, encodeURIComponent(String(requestParameters['characterId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCharactersCharacterIdFleetOkFromJSON(jsonValue));
    }

    /**
     * Return the fleet ID the character is in, if any.  ---  This route is cached for up to 60 seconds  --- Warning: This route has an upgrade available  --- [Diff of the upcoming changes](https://esi.evetech.net/diff/latest/dev/#GET-/characters/{character_id}/fleet/)
     * Get character fleet info
     */
    async getCharactersCharacterIdFleet(requestParameters: GetCharactersCharacterIdFleetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCharactersCharacterIdFleetOk> {
        const response = await this.getCharactersCharacterIdFleetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return details about a fleet  ---  This route is cached for up to 5 seconds
     * Get fleet information
     */
    async getFleetsFleetIdRaw(requestParameters: GetFleetsFleetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFleetsFleetIdOk>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling getFleetsFleetId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.read_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFleetsFleetIdOkFromJSON(jsonValue));
    }

    /**
     * Return details about a fleet  ---  This route is cached for up to 5 seconds
     * Get fleet information
     */
    async getFleetsFleetId(requestParameters: GetFleetsFleetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFleetsFleetIdOk> {
        const response = await this.getFleetsFleetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return information about fleet members  ---  This route is cached for up to 5 seconds
     * Get fleet members
     */
    async getFleetsFleetIdMembersRaw(requestParameters: GetFleetsFleetIdMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFleetsFleetIdMembers200Ok>>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling getFleetsFleetIdMembers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.read_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/members/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFleetsFleetIdMembers200OkFromJSON));
    }

    /**
     * Return information about fleet members  ---  This route is cached for up to 5 seconds
     * Get fleet members
     */
    async getFleetsFleetIdMembers(requestParameters: GetFleetsFleetIdMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFleetsFleetIdMembers200Ok>> {
        const response = await this.getFleetsFleetIdMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return information about wings in a fleet  ---  This route is cached for up to 5 seconds
     * Get fleet wings
     */
    async getFleetsFleetIdWingsRaw(requestParameters: GetFleetsFleetIdWingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetFleetsFleetIdWings200Ok>>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling getFleetsFleetIdWings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.read_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/wings/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetFleetsFleetIdWings200OkFromJSON));
    }

    /**
     * Return information about wings in a fleet  ---  This route is cached for up to 5 seconds
     * Get fleet wings
     */
    async getFleetsFleetIdWings(requestParameters: GetFleetsFleetIdWingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetFleetsFleetIdWings200Ok>> {
        const response = await this.getFleetsFleetIdWingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite a character into the fleet. If a character has a CSPA charge set it is not possible to invite them to the fleet using ESI  --- 
     * Create fleet invitation
     */
    async postFleetsFleetIdMembersRaw(requestParameters: PostFleetsFleetIdMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling postFleetsFleetIdMembers().'
            );
        }

        if (requestParameters['invitation'] == null) {
            throw new runtime.RequiredError(
                'invitation',
                'Required parameter "invitation" was null or undefined when calling postFleetsFleetIdMembers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/members/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostFleetsFleetIdMembersInvitationToJSON(requestParameters['invitation']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Invite a character into the fleet. If a character has a CSPA charge set it is not possible to invite them to the fleet using ESI  --- 
     * Create fleet invitation
     */
    async postFleetsFleetIdMembers(requestParameters: PostFleetsFleetIdMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postFleetsFleetIdMembersRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new wing in a fleet  --- 
     * Create fleet wing
     */
    async postFleetsFleetIdWingsRaw(requestParameters: PostFleetsFleetIdWingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostFleetsFleetIdWingsCreated>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling postFleetsFleetIdWings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/wings/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFleetsFleetIdWingsCreatedFromJSON(jsonValue));
    }

    /**
     * Create a new wing in a fleet  --- 
     * Create fleet wing
     */
    async postFleetsFleetIdWings(requestParameters: PostFleetsFleetIdWingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostFleetsFleetIdWingsCreated> {
        const response = await this.postFleetsFleetIdWingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new squad in a fleet  --- 
     * Create fleet squad
     */
    async postFleetsFleetIdWingsWingIdSquadsRaw(requestParameters: PostFleetsFleetIdWingsWingIdSquadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostFleetsFleetIdWingsWingIdSquadsCreated>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling postFleetsFleetIdWingsWingIdSquads().'
            );
        }

        if (requestParameters['wingId'] == null) {
            throw new runtime.RequiredError(
                'wingId',
                'Required parameter "wingId" was null or undefined when calling postFleetsFleetIdWingsWingIdSquads().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/wings/{wing_id}/squads/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"wing_id"}}`, encodeURIComponent(String(requestParameters['wingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostFleetsFleetIdWingsWingIdSquadsCreatedFromJSON(jsonValue));
    }

    /**
     * Create a new squad in a fleet  --- 
     * Create fleet squad
     */
    async postFleetsFleetIdWingsWingIdSquads(requestParameters: PostFleetsFleetIdWingsWingIdSquadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostFleetsFleetIdWingsWingIdSquadsCreated> {
        const response = await this.postFleetsFleetIdWingsWingIdSquadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update settings about a fleet  --- 
     * Update fleet
     */
    async putFleetsFleetIdRaw(requestParameters: PutFleetsFleetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling putFleetsFleetId().'
            );
        }

        if (requestParameters['newSettings'] == null) {
            throw new runtime.RequiredError(
                'newSettings',
                'Required parameter "newSettings" was null or undefined when calling putFleetsFleetId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutFleetsFleetIdNewSettingsToJSON(requestParameters['newSettings']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update settings about a fleet  --- 
     * Update fleet
     */
    async putFleetsFleetId(requestParameters: PutFleetsFleetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putFleetsFleetIdRaw(requestParameters, initOverrides);
    }

    /**
     * Move a fleet member around  --- 
     * Move fleet member
     */
    async putFleetsFleetIdMembersMemberIdRaw(requestParameters: PutFleetsFleetIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling putFleetsFleetIdMembersMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling putFleetsFleetIdMembersMemberId().'
            );
        }

        if (requestParameters['movement'] == null) {
            throw new runtime.RequiredError(
                'movement',
                'Required parameter "movement" was null or undefined when calling putFleetsFleetIdMembersMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/members/{member_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"member_id"}}`, encodeURIComponent(String(requestParameters['memberId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutFleetsFleetIdMembersMemberIdMovementToJSON(requestParameters['movement']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Move a fleet member around  --- 
     * Move fleet member
     */
    async putFleetsFleetIdMembersMemberId(requestParameters: PutFleetsFleetIdMembersMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putFleetsFleetIdMembersMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * Rename a fleet squad  --- 
     * Rename fleet squad
     */
    async putFleetsFleetIdSquadsSquadIdRaw(requestParameters: PutFleetsFleetIdSquadsSquadIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling putFleetsFleetIdSquadsSquadId().'
            );
        }

        if (requestParameters['squadId'] == null) {
            throw new runtime.RequiredError(
                'squadId',
                'Required parameter "squadId" was null or undefined when calling putFleetsFleetIdSquadsSquadId().'
            );
        }

        if (requestParameters['naming'] == null) {
            throw new runtime.RequiredError(
                'naming',
                'Required parameter "naming" was null or undefined when calling putFleetsFleetIdSquadsSquadId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/squads/{squad_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"squad_id"}}`, encodeURIComponent(String(requestParameters['squadId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutFleetsFleetIdSquadsSquadIdNamingToJSON(requestParameters['naming']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rename a fleet squad  --- 
     * Rename fleet squad
     */
    async putFleetsFleetIdSquadsSquadId(requestParameters: PutFleetsFleetIdSquadsSquadIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putFleetsFleetIdSquadsSquadIdRaw(requestParameters, initOverrides);
    }

    /**
     * Rename a fleet wing  --- 
     * Rename fleet wing
     */
    async putFleetsFleetIdWingsWingIdRaw(requestParameters: PutFleetsFleetIdWingsWingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fleetId'] == null) {
            throw new runtime.RequiredError(
                'fleetId',
                'Required parameter "fleetId" was null or undefined when calling putFleetsFleetIdWingsWingId().'
            );
        }

        if (requestParameters['wingId'] == null) {
            throw new runtime.RequiredError(
                'wingId',
                'Required parameter "wingId" was null or undefined when calling putFleetsFleetIdWingsWingId().'
            );
        }

        if (requestParameters['naming'] == null) {
            throw new runtime.RequiredError(
                'naming',
                'Required parameter "naming" was null or undefined when calling putFleetsFleetIdWingsWingId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-fleets.write_fleet.v1"]);
        }

        const response = await this.request({
            path: `/v1/fleets/{fleet_id}/wings/{wing_id}/`.replace(`{${"fleet_id"}}`, encodeURIComponent(String(requestParameters['fleetId']))).replace(`{${"wing_id"}}`, encodeURIComponent(String(requestParameters['wingId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutFleetsFleetIdWingsWingIdNamingToJSON(requestParameters['naming']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rename a fleet wing  --- 
     * Rename fleet wing
     */
    async putFleetsFleetIdWingsWingId(requestParameters: PutFleetsFleetIdWingsWingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putFleetsFleetIdWingsWingIdRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const DeleteFleetsFleetIdMembersMemberIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type DeleteFleetsFleetIdMembersMemberIdDatasourceEnum = typeof DeleteFleetsFleetIdMembersMemberIdDatasourceEnum[keyof typeof DeleteFleetsFleetIdMembersMemberIdDatasourceEnum];
/**
 * @export
 */
export const DeleteFleetsFleetIdSquadsSquadIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type DeleteFleetsFleetIdSquadsSquadIdDatasourceEnum = typeof DeleteFleetsFleetIdSquadsSquadIdDatasourceEnum[keyof typeof DeleteFleetsFleetIdSquadsSquadIdDatasourceEnum];
/**
 * @export
 */
export const DeleteFleetsFleetIdWingsWingIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type DeleteFleetsFleetIdWingsWingIdDatasourceEnum = typeof DeleteFleetsFleetIdWingsWingIdDatasourceEnum[keyof typeof DeleteFleetsFleetIdWingsWingIdDatasourceEnum];
/**
 * @export
 */
export const GetCharactersCharacterIdFleetDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetCharactersCharacterIdFleetDatasourceEnum = typeof GetCharactersCharacterIdFleetDatasourceEnum[keyof typeof GetCharactersCharacterIdFleetDatasourceEnum];
/**
 * @export
 */
export const GetFleetsFleetIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetFleetsFleetIdDatasourceEnum = typeof GetFleetsFleetIdDatasourceEnum[keyof typeof GetFleetsFleetIdDatasourceEnum];
/**
 * @export
 */
export const GetFleetsFleetIdMembersAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetFleetsFleetIdMembersAcceptLanguageEnum = typeof GetFleetsFleetIdMembersAcceptLanguageEnum[keyof typeof GetFleetsFleetIdMembersAcceptLanguageEnum];
/**
 * @export
 */
export const GetFleetsFleetIdMembersDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetFleetsFleetIdMembersDatasourceEnum = typeof GetFleetsFleetIdMembersDatasourceEnum[keyof typeof GetFleetsFleetIdMembersDatasourceEnum];
/**
 * @export
 */
export const GetFleetsFleetIdMembersLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetFleetsFleetIdMembersLanguageEnum = typeof GetFleetsFleetIdMembersLanguageEnum[keyof typeof GetFleetsFleetIdMembersLanguageEnum];
/**
 * @export
 */
export const GetFleetsFleetIdWingsAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetFleetsFleetIdWingsAcceptLanguageEnum = typeof GetFleetsFleetIdWingsAcceptLanguageEnum[keyof typeof GetFleetsFleetIdWingsAcceptLanguageEnum];
/**
 * @export
 */
export const GetFleetsFleetIdWingsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetFleetsFleetIdWingsDatasourceEnum = typeof GetFleetsFleetIdWingsDatasourceEnum[keyof typeof GetFleetsFleetIdWingsDatasourceEnum];
/**
 * @export
 */
export const GetFleetsFleetIdWingsLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetFleetsFleetIdWingsLanguageEnum = typeof GetFleetsFleetIdWingsLanguageEnum[keyof typeof GetFleetsFleetIdWingsLanguageEnum];
/**
 * @export
 */
export const PostFleetsFleetIdMembersDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PostFleetsFleetIdMembersDatasourceEnum = typeof PostFleetsFleetIdMembersDatasourceEnum[keyof typeof PostFleetsFleetIdMembersDatasourceEnum];
/**
 * @export
 */
export const PostFleetsFleetIdWingsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PostFleetsFleetIdWingsDatasourceEnum = typeof PostFleetsFleetIdWingsDatasourceEnum[keyof typeof PostFleetsFleetIdWingsDatasourceEnum];
/**
 * @export
 */
export const PostFleetsFleetIdWingsWingIdSquadsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PostFleetsFleetIdWingsWingIdSquadsDatasourceEnum = typeof PostFleetsFleetIdWingsWingIdSquadsDatasourceEnum[keyof typeof PostFleetsFleetIdWingsWingIdSquadsDatasourceEnum];
/**
 * @export
 */
export const PutFleetsFleetIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PutFleetsFleetIdDatasourceEnum = typeof PutFleetsFleetIdDatasourceEnum[keyof typeof PutFleetsFleetIdDatasourceEnum];
/**
 * @export
 */
export const PutFleetsFleetIdMembersMemberIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PutFleetsFleetIdMembersMemberIdDatasourceEnum = typeof PutFleetsFleetIdMembersMemberIdDatasourceEnum[keyof typeof PutFleetsFleetIdMembersMemberIdDatasourceEnum];
/**
 * @export
 */
export const PutFleetsFleetIdSquadsSquadIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PutFleetsFleetIdSquadsSquadIdDatasourceEnum = typeof PutFleetsFleetIdSquadsSquadIdDatasourceEnum[keyof typeof PutFleetsFleetIdSquadsSquadIdDatasourceEnum];
/**
 * @export
 */
export const PutFleetsFleetIdWingsWingIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PutFleetsFleetIdWingsWingIdDatasourceEnum = typeof PutFleetsFleetIdWingsWingIdDatasourceEnum[keyof typeof PutFleetsFleetIdWingsWingIdDatasourceEnum];
